import { Component, output, Input } from '@angular/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'platform-integration-search-bar',
  imports: [GalaxyFormFieldModule, FormsModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  standalone: true,
})
export class SearchBarComponent {
  searchTermChange = output<string>();
  @Input() searchTerm = '';

  onSearchChange(value: string) {
    this.searchTerm = value;
    this.searchTermChange.emit(value);
  }
}
